import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
  StandaloneSearchBox,
} from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '300px',
};

const defaultCenter = {
  lat: 40.4168,
  lng: -3.7038,
};

const libraries = ['places']; // Necesario para el buscador

function MapaSeleccion({ location, setLocation }) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyB7Sx1jXG9YS5c7Iy-qxOEfkECMh7syeqg', // Reemplaza con tu key
    libraries,
  });

  const [mapCenter, setMapCenter] = useState(location || defaultCenter);
  const searchBoxRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!location && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const current = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };
          setLocation(current);
          setMapCenter(current);
        },
        (err) => console.warn('Ubicación no permitida:', err)
      );
    }
  }, [location, setLocation]);

  const onMapClick = useCallback(
    (event) => {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      const pos = { lat, lng };
      setLocation(pos);
      setMapCenter(pos);
    },
    [setLocation]
  );

  const onPlacesChanged = () => {
    const places = searchBoxRef.current.getPlaces();
    if (places.length === 0) return;

    const { geometry } = places[0];
    const pos = {
      lat: geometry.location.lat(),
      lng: geometry.location.lng(),
    };
    setLocation(pos);
    setMapCenter(pos);
  };

  if (!isLoaded) return <div>Cargando mapa...</div>;

  return (
    <div>
    
        

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={mapCenter}
        zoom={14}
        onClick={onMapClick}
        onLoad={(map) => (mapRef.current = map)}
        options={{
          gestureHandling: 'greedy',
          disableDefaultUI: false,
        }}
      >
        {location && <Marker position={location} />}
      </GoogleMap>
    </div>
  );
}

export default React.memo(MapaSeleccion);
